// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__r0WGu","info":"Note_info__PGC1X","note":"Note_note__3Wn7G","actions":"Note_actions__2VDwi"};